export default () => ({
    selectedPackagingProject: null,
    searchQueryData: {
        query: '',
        sort: {icon: 'sort-alphabetical-ascending', text: 'Alphabetically ascending', value: 'ASCENDING'},
        projectType: {icon: '', text: 'All', value: 'ALL'},
        active: {icon: 'calendar-check', text: 'Active', value: 'Active'}
    },
    monitoringData: null,
    selectedPackagingDevice: null,
    dpLegendSelection: {
        READY: {name: 'Ready', value: true, color: '#1CAB80'},
        DATA_APPROVED: {name: 'Data Approved', value: true, color: '#8C84FF'},
        DATA_PACKAGED: {name: 'Data Packaged', value: true, color: '#0C6051'},
        NOT_READY: {name: 'Not Ready', value: true, color: 'black'}
    }
});
